import { render, staticRenderFns } from "./RedirectResultsNow.vue?vue&type=template&id=5a8770b8"
import script from "./RedirectResultsNow.vue?vue&type=script&lang=js"
export * from "./RedirectResultsNow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports